export default {
  /**
   * @description menu list
   * @returns {string}
   */
  menuList: {
    A: 'AI智能派工',
    B: '派工管理',
    C: '服務調查',
    D: '基本資料',
    E: '系統設定',
  },
  casePriority: {
    high: 1,
    normal: 2,
  },
  caseFlgStatus: {
    close: 'C',
    open: 'O',
  },
  satisfactionFlgStatus: {
    open: 'A',
    send: 'E',
    close: 'F',
  },
  CaseTypeEnums: {
    install: {value: 1, stringValue: '安裝/試車'},
    repair: {value: 2, stringValue: '修理'},
    retrofit: {value: 3, stringValue: '改造'},
    maintenance: {value: 4, stringValue: '保養'},
    support: {value: 5, stringValue: '技術支援'},
    other: {value: 6, stringValue: '其他'},
    training: {value: 7, stringValue: '教育訓練'},
  },
  httpStatusCode: {
    successCode: '200',
    errorCode: '500',
  },
  accessModeEnums: {
    create: 'create',
    read: 'read',
    update: 'update',
    delete: 'delete',
  },
  moduleEnums: {
    ELEVATOR: '電梯資料',
    case: '案件總覽',
    caseApply: '案件申請',
    ELEVATOR_APPLY: '梯控申請',
    BUILDING: '大樓資料',
    ROLE_PERMISSION: '角色權限',
    ACCOUNT_MANAGEMENT: '帳號管理',
    position: '職位管理',
    department: '部門資料',
    employee: '員工資料',
    customer: '客戶資料',
    condition: '指派條件',
    dispatchManagement: '派工管理',
    satisfactionSurvey: '滿意度調查',
    satisfactionManagement: '滿意度管理',
    machine: '機器資料',
    appearance: '現象管理',
  },
  modalMode: {
    new: 'new',
    edit: 'edit',
  },
  messageModalMode: {
    loading: 'loading',
    error: 'error',
    warning: 'warning',
    info: 'info',
  },
  flgStatus: {
    active: 'A',
    inactive: 'I',
  },
  alertModalModeEnums: {
    delete: 'delete',
    enable: 'enable',
    disable: 'disable',
    approve: 'approve',
    resetPassword: 'resetPassword',
  },
  targetAction: {
    department: 'department',
    employee: 'employee',
    customer: 'customer',
    case: 'case',
    position: 'position',
  },
  assignmentFlgStatus: {
    CLOSE: {
      value: 'A',
      text: '已派工待處理',
      variation: 'status-active',
    },
    OPEN: {value: 'P', text: '執行中', variation: 'status-process'},
    DRAFT: {value: 'D', text: '草稿', variation: 'status-draft'},
    FINISH: {
      value: 'F',
      text: '已完成',
      variation: 'status-finish',
    },
    NONE: {
      value: 'N',
      text: '未指派',
      variation: 'status-danger',
    },
    EXPIRED: {
      value: 'E',
      text: '已逾期',
      variation: 'status-danger',
    },
  },

  machineTypes: {
    1: 'FRD',
    2: 'FRS',
    3: 'FRC',
    4: 'RRS',
    5: 'NGT',
    6: 'EGR',
    7: 'TST',
    8: 'KKS',
    9: 'SMD',
    10: 'FRN',
    11: 'WEL',
    12: 'MSK',
    13: 'OKK',
    14: 'FRO',
    15: 'OTH',
  },
  disabled: true,
};
